export default from './SecondaryNav';



// WEBPACK FOOTER //
// ./src/sharedComponents/SecondaryNav/index.js